// extracted by mini-css-extract-plugin
module.exports = {"testList":"testListIcon_testList__GWEwW","icon":"testListIcon_icon__2NZp9","name":"testListIcon_name__2rStY","status":"testListIcon_status__23O7M"};